// packages/web/src/api/user-replacements/mutations.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userReplacementsCreate, userReplacementsDelete } from "../generated/sdk.gen.ts";

export function useCreateReplacement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { approverId: string; replacementId: string }) => {
      const { data, error } = await userReplacementsCreate({ body: vars });
      if (error) throw error;
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["userReplacements"] }),
  });
}

export function useDeleteReplacement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { id: string }) => {
      const { data, error } = await userReplacementsDelete({ path: { id: vars.id } });
      if (error) throw error;
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["userReplacements"] }),
  });
}
